exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  display: block;\n  position: relative;\n  height: 80px;\n  z-index: 1;\n  margin-bottom: 20px; }\n  .navbar__logo {\n    position: absolute;\n    left: 10px;\n    top: 15px;\n    width: 90px; }\n  .navbar__button--margintop {\n    margin-top: 18px; }\n  .navbar .brand__title {\n    padding: 22px 15px 20px 15px;\n    color: #FFF;\n    font-size: 14px;\n    margin-top: -25px;\n    margin-bottom: -30px; }\n  .navbar .navlink {\n    float: left;\n    padding: 22px 15px 20px 15px;\n    font-size: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/navbar/navbar.component.scss
// module id = ../../../../../src/app/navbar/navbar.component.scss
// module chunks = main